/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   13/09/2016 2:55 PM
 * @Email:  alex@yuion.net
 * @Filename: input-field.component.ts
 * @Last modified by:   Alex Sorafumo
 * @Last modified time: 27/01/2017 5:30 PM
 */

import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormWidgetComponent } from '../../../shared/base-form.component';

@Component({
    selector: 'input-field',
    styles: [`.input-field{display:inline-block;font-size:1em;padding:8px 0 4px;margin:.5em 0 .2em;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom:1px solid #ccc;min-width:12em;-webkit-transition:border .3s;transition:border .3s}.input-field.fill{min-width:0}.input-field.right input{text-align:right}.input-field.error{border-color:#f44336}.input-field.focus{border-color:#2196f3}.input-field.disable{opacity:.2;pointer-events:none}.field{position:relative}input{width:100%;color:rgba(0,0,0,.87);font-size:1em;border:none;outline:0;-webkit-appearance:none;-webkit-box-shadow:none;box-shadow:none;border-radius:0;padding:0;margin:0;background:0 0}.placeholder{position:absolute;top:50%;left:0;font-size:1em;-webkit-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:font-size .3s,top .3s,color .3s;transition:font-size .3s,top .3s,color .3s;color:rgba(0,0,0,.2);pointer-events:none}.placeholder.focus{color:#2196f3}.placeholder.hide{top:-.8em;font-size:.6em}`],
    template: `<!--
@Author: Alex Sorafumo <Yuion>
@Date:   13/09/2016 2:55 PM
@Email:  alex@yuion.net
@Filename: input-field.template.html
@Last modified by:   Yuion
@Last modified time: 15/12/2016 11:29 AM
-->

<div [class]="'input-field' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '')" widget [class.focus]="state.focus">
    <div class="field">
        <div class="placeholder" [class.focus]="state.focus" [class.hide]="model">
            {{placeholder}}
        </div>
        <input #input [type]="type" [(ngModel)]="model" (ngModelChange)="valueChanged($event)" (focus)="focused($event)" (blur)="blurred($event)" [disabled]="disabled" [maxlength]="limit">
    </div>
</div>
`,
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputFieldComponent),
        multi: true
      }
    ]
})
export class InputFieldComponent extends BaseFormWidgetComponent<string> implements ControlValueAccessor {
    @Input() public type = 'text';
    @Input() public mask = '';
    @Input() public placeholder = '';
    @Input() public limit = 65535;
    @Output() public focus = new EventEmitter<FocusEvent>();
    @Output() public blur = new EventEmitter<FocusEvent>();

    public state: { [name: string]: any } = {};

    public focused(e?: FocusEvent) {
        this.state.focus = true;
        this.focus.emit(e);
    }

    public blurred(e?: FocusEvent) {
        this.state.focus = false;
        this.blur.emit(e);
    }

    public valueChanged(value: string) {
        this.modelChange.emit(value);
    }

}
